import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { AuthService } from '../../auth/auth.service';

const endpoint = environment.apiBaseUrl + '/admin/validaciones/v1';

const httpOptions = {
    headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/octet-stream'
    }),
};

@Injectable({
    providedIn: "root",
})
export class ValidacionesService {

    constructor(private httpClient: HttpClient, private authService: AuthService) {

    }

    private extractData(res: Response) {
        const body = res;
        return body || {};
    }

    //HTTP
    //Cargar el árbol y las preguntas frecuentes con sus ids.
    loadValidaciones(habilitado) {
        return this.httpClient.get<any>(endpoint + `/list?habilitado=${habilitado}`).pipe(map(this.extractData));  
    }

    loadValidacionByID(idValidacion) {
        return this.httpClient.get<any>(endpoint + `/display/${idValidacion}`).pipe(map(this.extractData));
    }

    salirAdministrador() {
        this.authService.logout();
    }

    agregarValidacion(codigo, nombre, tipo, updateUser) {
       // debugger
        const params = {
            codigo: codigo,
            nombre: nombre,
            tipo: tipo,
            usuarioActualizador: updateUser
        }
        return this.httpClient.post(`${endpoint}/add`, params)
    }

    actualizarValidacion(idValidacion, codigo, nombre, tipo, updateUser, habilitado) {
        const params = {
            id: idValidacion,
            codigo: codigo,
            nombre: nombre,
            tipo: tipo,
            usuarioActualizador: updateUser,
            habilitado: habilitado
        }
        return this.httpClient.post(`${endpoint}/update`, params)
    }

    deleteValidacion(id,updateUser) {
        const params = {
            id
        }
        return this.httpClient.post(`${endpoint}/delete/${id}/${updateUser}`, params);
    }
}
